function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "21.7344142%",
  y1: "24.5627858%",
  x2: "130.610154%",
  y2: "129.806096%",
  id: "linearGradient-1-warningIconSuccess"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  stopOpacity: 0.989470109,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-warningIconSuccess",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "37-desktop-UI",
  transform: "translate(-114.000000, -1416.000000)"
}, React.createElement("g", {
  id: "Group-17-warningIconSuccess",
  transform: "translate(114.000000, 1416.000000)"
}, React.createElement("path", {
  d: "M21,42 C32.5979797,42 42,32.5979797 42,21 C42,9.40202025 32.5979797,0 21,0 C9.40202025,0 0,9.40202025 0,21 C0,32.5979797 9.40202025,42 21,42 Z",
  id: "Oval-warningIconSuccess",
  fill: "url(#linearGradient-1-warningIconSuccess)"
}), React.createElement("path", {
  d: "M21.5978261,24.4795918 L19.326087,24.4795918 L19.076087,14 L21.8586957,14 L21.5978261,24.4795918 Z M19,27.6836735 C19,27.2959164 19.1340566,26.9744911 19.4021739,26.7193878 C19.6702912,26.4642844 20.0362296,26.3367347 20.5,26.3367347 C20.9637704,26.3367347 21.3297088,26.4642844 21.5978261,26.7193878 C21.8659434,26.9744911 22,27.2959164 22,27.6836735 C22,28.057825 21.8695665,28.370747 21.6086957,28.622449 C21.3478248,28.8741509 20.9782633,29 20.5,29 C20.0217367,29 19.6521752,28.8741509 19.3913043,28.622449 C19.1304335,28.370747 19,28.057825 19,27.6836735 L19,27.6836735 Z",
  id: "Icon-warningIconSuccess",
  fill: "#FFFFFF",
  transform: "translate(20.500000, 21.500000) scale(1, -1) translate(-20.500000, -21.500000) "
}))));

var SvgWarningIconSuccess = function SvgWarningIconSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningIconSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warningIconSuccess.f66e1cd5.svg";
export { ForwardRef as ReactComponent };